import AddPersonForm from '@/components/features/People/forms/AddPersonForm';
import { useTranslations } from '@/hooks/useTranslations';
import CreateLayout from '@/layouts/create-layout';
import { type BreadcrumbItem } from '@/types';
import { Head } from '@inertiajs/react';

export default function CreatePerson() {
    const { t } = useTranslations();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: t('dashboard.breadcrumbs.dashboard', 'Dashboard'),
            href: '/dashboard',
        },
        {
            title: t('people.index.breadcrumbs.people', 'People'),
            href: '/people',
        },
        {
            title: t('people.create.breadcrumbs.create', 'Create'),
            href: '/people/create',
        },
    ];

    return (
        <CreateLayout
            breadcrumbs={breadcrumbs}
            title={t('people.create.heading', 'Create Contact')}
            subtitle={t('people.create.subheading', 'Add a new contact person to your system')}
        >
            <Head title={t('people.create.title', 'Create Contact')} />
            <AddPersonForm
                onSuccess={() => {
                    // The form will handle navigation after successful creation
                }}
            />
        </CreateLayout>
    );
}
